// Copyright (c) StrangeBee 2023

import { ReactElement, memo, useEffect, useState } from 'react';
import { classList } from '@Helpers/className';
import Papa from 'papaparse';

import './CSVPreview.scss';

interface CSVPreviewProps {
    src: string;
    className?: string;
}

export const CSVPreview = memo(({ src, className }: CSVPreviewProps): ReactElement => {
    const [csvData, setCsvData] = useState<any[]>([]);

    useEffect(() => {
        Papa.parse(src, {
            complete: (result) => {
                setCsvData(result?.data);
            },
        });
    }, [src]);

    return (
        <div className={classList('CSVPreview', className)}>
            {csvData.length && (
                <table className="CSVPreview__Table">
                    <tbody>
                        {csvData.map((row, index) => (
                            <tr className="CSVPreview__Row" key={index}>
                                {row.map((cell: any, cellIndex: number) => (
                                    <td className="CSVPreview__Cell" key={cellIndex}>
                                        {cell}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
});
